export default {
  name: "bm-menu",
  components: {},
  props: [
    "title",
    "subtitle",
    "selectedItems",
    "items",
    "selectedIcon",
    "unselectedIcon",
    "visible",
    "nameProp",
    "hideIcon",
    "idProp"
  ],
  data() {
    return {
      inited: false,
      sIcon: "fas fa-check-circle",
      usIcon: "far fa-circle"
    };
  },
  computed: {},
  mounted() {
    if (this.selectedIcon && this.selectedIcon != "") {
      this.sIcon = this.selectedIcon;
    }

    if (this.unselectedIcon && this.unselectedIcon != "") {
      this.usIcon = this.unselectedIcon;
    }
  },
  watch: {
    selectedItems: {
      handler: function(after, before) {
        if (after.length != before.length) {
          this.SyncSelectedItems();
        }
      }
    }
  },
  methods: {
    Hide() {
      this.$nextTick(() => {
        this.$emit("update:visible", false);
      });
    },

    SyncSelectedItems() {
      this.$nextTick(() => {
        for (let item of this.items) {
          let found = this.selectedItems.find(
            x => x[this.idProp] === item[this.idProp]
          );

          if (found) {
            this.$set(item, "selected", true);
          } else {
            this.$set(item, "selected", false);
          }
        }
      });
    },

    UpdateSelectedItem(obj) {
      this.$nextTick(() => {
        this.$set(obj, "selected", !obj.selected);
        let found = this.selectedItems.find(
          x => x[this.idProp] === obj[this.idProp]
        );

        if (!found && obj.selected) {
          this.selectedItems.push(obj);
          this.$emit("added", obj);
        } else if (found && !obj.selected) {
          let i = this.selectedItems.indexOf(found);
          this.selectedItems.splice(i, 1);
          this.$emit("removed", found);
        }
      });
    }
  }
};
